import { render, staticRenderFns } from "./UserNavigationLinks.vue?vue&type=template&id=061ae2a7&scoped=true&"
import script from "./UserNavigationLinks.vue?vue&type=script&lang=js&"
export * from "./UserNavigationLinks.vue?vue&type=script&lang=js&"
import style0 from "./UserNavigationLinks.vue?vue&type=style&index=0&id=061ae2a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ae2a7",
  null
  
)

export default component.exports